import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';
import type { LeaseActionProps } from '../../../models/Types';
import { Lease } from '../../../models';

export default function RedirectToLeaseExtensionPreRenewalWizard({
  history,
  terminateActiveAction,
  lease,
}: LeaseActionProps) {
  const { leaseId } = useLeasingUrlParams();

  history.push(Lease.getManageYourLeasePath(leaseId || lease.id));
  terminateActiveAction();
  return null;
}
